<template>
    <div>
        
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">Penerimaan QR</h2>
            </div>
            <div class="p-2 bd-highlight" style="width: 150px;">
                <div class="row"> 
                    <div class="col-12 mt-auto mb-auto">
                        Saldo QR : 10,000
                    </div>
                    <!-- <div class="col-7">
                        <button class="btn shadow w-100 bg-white">
                            <i class="fa fa-file-pdf">&nbsp; Download Template</i>
                        </button>
                    </div> -->
                </div>
            </div>
        </div>


        <qr-receipt-from-qtrust
            class="mt-4"
        ></qr-receipt-from-qtrust>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import qrReceiptFromQtrust from './children/qrReceiptFromQtrustTable.vue'

export default {
    metaInfo : {
        title : 'QR Issue'
    },
    components : {
        Multiselect,
        qrReceiptFromQtrust
    },
    data () {
        let startDate = moment().startOf('month').format("MM-DD-Y");
        let currentDate = moment().format("MM-DD-Y");
        return {
            rangePickr: {
                mode: 'range',
                dateFormat: "m-d-Y",
                altInput: true,
                altInputClass: 'form-control input bg-white h-47px',
                altFormat : 'm-d-Y'
            },
            selected : {
                date : `${startDate} to ${currentDate}`
            },
        }
    }
}
</script>